import ReactStars from 'react-rating-stars-component'
import './loopview.css'

const LoopSevenbody = ({ data, setStarCount, comment, setComment }) => {
  const handleCommentChange = e => {
    setComment(e.target.value)
  }
  return (
    <div>
      <h5 className='title'>{data.TitleName}</h5>

      <p className='bodytext1'>Rate this loop</p>

      <ReactStars
        count={5}
        value={0}
        isHalf={false}
        size={40}
        activeColor='#D9B65B'
        onChange={newRating => setStarCount(newRating)}
      />

      <textarea
        type='text'
        onChange={handleCommentChange}
        maxLength={160}
        placeholder='Add a comment...'
        className='activity-input'
      />

      <div style={{ textAlign: 'right', fontSize: '0.85rem', color: '#555' }}>
        {comment.length}/160
      </div>
    </div>
  )
}
export default LoopSevenbody
